export default __webpack_public_path__ + "static/media/mobile_banner.d5241c31.jpg";